import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private subject = new Subject<boolean>();
  private loadingMap: Map<string, boolean> = new Map<string, boolean>();

  constructor() {
  }

  returnSpinner(){
    return this.subject.asObservable();
  }

  openSpinner(){
    this.subject.next(true);
  }

  closeSpinner(){
    this.subject.next(false);
  }

  setLoading(loading: boolean, url: string) {
    if(!url){
      throw new Error("Debe setear una url para setear el spinner");
    }
    if(loading === true){
      this.loadingMap.set(url, loading);
      this.openSpinner();
    } else if( loading === false && this.loadingMap.has(url)){
      this.loadingMap.delete(url);
    }
    if(this.loadingMap.size === 0){
      this.closeSpinner();
    }
  }
}